module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('section', [(_vm.$route.path == '/SendGoods/SendGoods') ? _c('div', [_c('el-form', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售下单号:",
      "label-width": "90px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.OrderCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "OrderCode", $$v)
      },
      expression: "query.OrderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货通知单号:",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.SendCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "SendCode", $$v)
      },
      expression: "query.SendCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.AgentName),
      callback: function($$v) {
        _vm.$set(_vm.query, "AgentName", $$v)
      },
      expression: "query.AgentName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区域:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.AreaName),
      callback: function($$v) {
        _vm.$set(_vm.query, "AreaName", $$v)
      },
      expression: "query.AreaName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户客服:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.BusUser),
      callback: function($$v) {
        _vm.$set(_vm.query, "BusUser", $$v)
      },
      expression: "query.BusUser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核状态:",
      "label-width": "80px"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.Status),
      callback: function($$v) {
        _vm.$set(_vm.query, "Status", $$v)
      },
      expression: "query.Status"
    }
  }, _vm._l((_vm.queryType), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.TypeValue,
        "label": option.TypeName
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuerySubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete2"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_vm._v("\n\t\t\t\t\t未审核" + _vm._s(_vm.AuditNum.UnAuditNum) + "个，已审核" + _vm._s(_vm.AuditNum.AuditNum) + "个\n\t\t\t\t")]), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货通知单号",
      "prop": "SendCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售下单号",
      "prop": "OrderCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代理商",
      "prop": "AgentName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属区域",
      "prop": "AreaName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单下单时间",
      "prop": "SendTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商务客服",
      "prop": "BusUser"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "业务员",
      "prop": "SaleEmployeeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "StatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "view",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleView(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "icon": "check",
            "disabled": (scope.row.btnVue & 128) <= 0,
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.adoptHandle(scope.$index, scope.row)
            }
          }
        }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "icon": "close",
            "disabled": (scope.row.btnVue & 64) <= 0,
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.ReturnHandle(scope.$index, scope.row)
            }
          }
        }, [_vm._v("驳回")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _c('div', [_c('router-view')], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "销售下单审核",
      "size": "tiny"
    },
    model: {
      value: (_vm.SaleCheckView),
      callback: function($$v) {
        _vm.SaleCheckView = $$v
      },
      expression: "SaleCheckView"
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "100%"
    },
    attrs: {
      "label-width": "100px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.SaleCheckView = false
      }
    }
  }, [_vm._v("通 过")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.SaleCheckView = false
      }
    }
  }, [_vm._v("驳 回")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.SaleCheckView = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-352357a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendGoods/SendGoods.vue
// module id = 1446
// module chunks = 1